import { AxiosResponse } from "axios";
import api from "../api/base-api";
import refreshAxiosInstance from "../api/refersh-api";

const login = (username: string, password: string, keepAlive: boolean): Promise<AxiosResponse> => {
    return api.post("/auth/basic", { username, password, keepAlive });
};

const register = (data: Record<string, unknown>): Promise<AxiosResponse> => {
    return api.post("/auth/register", data);
};

const emailMeApi = (data: Record<string, unknown>): Promise<AxiosResponse> => {
    return api.post("/auth/resend-email-verification", data);
};

const logout = (refreshToken: string): Promise<AxiosResponse> => {
    return api.post("/auth/logout", { refreshToken });
};

const updateProfileNotification = (emailOpted: boolean): Promise<AxiosResponse> => {
    return api.post("/auth/update-email-opt-in", { email_opt_in: emailOpted });
};

const getAccountVerificationStatus = (id: string): Promise<AxiosResponse> => {
    return refreshAxiosInstance.get(`/auth/v1/verify/${id}`);
};

const getUserData = (accessToken: string): Promise<AxiosResponse> => {
    return api.get("/auth/me", {
        headers: { Authorization: `Bearer ${accessToken}` },
    });
};

const updateUserName = (
    accessToken: string,
    firstName: string,
    lastName: string
): Promise<AxiosResponse> => {
    return api.put("auth/update-name", {
        headers: { Authorization: `Bearer ${accessToken}` },
        firstName,
        lastName,
    });
};

const updatePassword = (
    accessToken: string,
    newPassword: string,
    oldPassword: string,
    doNotPersist: boolean = false
): Promise<AxiosResponse> => {
    return refreshAxiosInstance.put(
        "/auth/v1/change-password",
        { newPassword, oldPassword, doNotPersist },
        {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        }
    );
};

const AuthService = {
    login,
    logout,
    register,
    emailMeApi,
    updateProfileNotification,
    getAccountVerificationStatus,
    getUserData,
    updateUserName,
    updatePassword,
};

export default AuthService;
